module.exports = __webpack_public_path__ + "static/media/NeritoOurApp2.d850eb77.svg";